<template>
  <div class="empty-content">
    <img :src="emptyContentImage" alt="empty-content">
    <div class="title" v-html="emptyContentText"></div>
  </div>
</template>

<script>
  export default {
    name: 'empty-content',
  
    props: {
      emptyContentText: {
        type: String,
      },
      emptyContentImage: {
        type: String,
        default: '/static/images/img_empty_assignment.png',
      },
    },
  };
</script>

<style lang="scss" scoped>

  .empty-content {
    width: 348px;
    margin: 0 auto;

    img {
      width: 100px;
      height: 100px;
      margin-top: 24%;
      margin-right: auto;
      margin-left: auto;
      display: block;
    }

    .title {
      margin: 14px;
      color: #979797;
      text-align: center;
    }
  }

</style>


// WEBPACK FOOTER //
// EmptyContent.vue?294c80fb